import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { Folio } from 'src/app/interfaces/folios.interface';

import { VentaService } from 'src/app/services/venta.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-venta',
  templateUrl: './venta.component.html',
  styleUrls: ['./venta.component.css']
})
export class VentaComponent implements OnInit {

  qtyForm = this.fb.group({
    producto: [''],
    index: [''],
    qty: ['', Validators.required] 
  });

  barra = '';
  version = environment.version;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public service: VentaService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {

    this.service.obtenerFolios(39).subscribe((folio: Folio) => {
      this.service.folio = folio;
    });
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.service.scanAuto) {
      if (event.keyCode === 8) {
        this.borrarTermino();

      } else if (event.keyCode === 106) {
        this.barra += event.key;

      } else if ((event.keyCode >= 48 && event.keyCode <= 57) ||
      (event.keyCode >= 96 && event.keyCode <= 105)) {
        this.barra += event.key;

      } else if (event.keyCode === 13) {
        if (this.barra !== '') {
          if (this.barra === '1') {
            this.router.navigateByUrl('/remesa');
          } else if (this.barra === '2') {
            this.router.navigateByUrl('/salidas');
          } else {
            this.productoPorBarra(this.barra);
            this.barra = '';
          }
        }
      }
    }
  }

  async productoPorBarra(barra: string) {
    let cantidad = 1;

    const asterisco = barra.includes('*');
    if (asterisco) {
      const resultado = barra.split('*');
      cantidad = Number.parseInt(resultado[0], 10);
      barra = resultado[1];

      if (!cantidad) {
        this.toastr.error('comando mal ingresado.')
        return;
      }

      if (cantidad < 1) {
        this.toastr.error('comando mal ingresado.')
        return;
      }

      if (barra === '') {
        this.toastr.error('comando mal ingresado.')
        return;
      }
    }

    this.service.productoPorBarra(barra).subscribe(
      (response) => {
        if (0 in response) {
          const producto = response[0];
          producto.name = producto.name.replace(/[üéáíóúñÑÜÁÉÍÓÚ]+/g, 'x');
          if (producto.category !== 'ABARROTES') {
            this.toastr.warning('Debe Seleccionar este producto desde menu.');
          } else {
            this.service.agregarProductoLista(producto, cantidad);
            this.service.calcularTotal();
          }
        } else {
          this.router.navigateByUrl('/recepcion');
        }
      },
      error => {
        this.toastr.error(error);
      }
    );
  }

  borrarTermino() {
    if (this.barra.length > 1) {
      this.barra = this.barra.slice(0, this.barra.length - 1);
    } else if (this.barra.length === 1) {
      this.barra = '';
    }
  }



  // NUEVO

  opcionesProducto(index: number) {

    this.qtyForm.controls.producto.setValue(this.service.productos[index]);
    this.qtyForm.controls.index.setValue(index);
    this.qtyForm.controls.qty.setValue(this.service.productos[index].cantidad);

    $('#modelOpciones').modal({ keyboard: false });
  }

  cerrarModalOpciones() {
    $('#modelOpciones').modal('hide');
  }

  sumar() {
    let qty = Number.parseInt(this.qtyForm.controls.qty.value, 10);
    if (qty === 999) {
      return;
    }

    qty++;
    this.qtyForm.controls.qty.setValue(qty);
  }

  restar() {
    let qty = Number.parseInt(this.qtyForm.controls.qty.value, 10);
    if (qty === 1) {
      return;
    }

    qty--;
    this.qtyForm.controls.qty.setValue(qty);
  }

  setearQty() {
    const index = Number.parseInt(this.qtyForm.controls.index.value, 10);
    const qty = Number.parseInt(this.qtyForm.controls.qty.value, 10);
    this.service.productos[index].cantidad = qty;
    this.service.calcularTotal();
    this.cerrarModalOpciones();
  }

  quitarProducto() {
    const index = Number.parseInt(this.qtyForm.controls.index.value, 10);
    this.service.productos.splice(index, 1);
    this.service.calcularTotal();
    this.cerrarModalOpciones();
  }
}
